import React from 'react';
import proptypes from 'prop-types';
const { shape, string: stringType } = proptypes;
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { QueryProvider, extend } from '@thd-nucleus/data-sources';
import { ThumbsUpThumbsDownWithPopover } from '@thd-olt-component-react/user-feedback';

const SmartFilterUserFeedback = ({ keyword, data: { dimensions, freeText, categoryId, categoryTaxonomy, requestId } }) => {

  return (
    <ErrorBoundary data-name="smart-filter-pro-tip-feedback">
      <QueryProvider
        cacheKey="smart-filter-user-feedback"
      >
        <div data-testid="smart-filter-pro-tip-feedback" className="sui-flex sui-justify-start sui-pt-2">
          <ThumbsUpThumbsDownWithPopover
            title="Was this helpful?"
            anchorKey={keyword}
            anchorType="PLP"
            customerInsights="SmartFilter"
            handleFeedbackData={() => {
              return {
                smartFilters: JSON.stringify({
                  dimensions,
                  freeText,
                  categoryId,
                  categoryTaxonomy,
                  requestId
                })
              };
            }}
          />
        </div>
      </QueryProvider>
    </ErrorBoundary>
  );
};

SmartFilterUserFeedback.displayName = 'SmartFilterUserFeedback';

SmartFilterUserFeedback.propTypes = {
  keyword: stringType,
  data: shape({})
};

SmartFilterUserFeedback.defaultProps = {
  keyword: '',
  data: {}
};

SmartFilterUserFeedback.dataModel = extend(ThumbsUpThumbsDownWithPopover);

export { SmartFilterUserFeedback };
